/**
 * AuthShell — cinematic full-bleed frame for sign-in style screens (display
 * name, invitation code, admin key). Wordmark top-left, a red-lit backdrop,
 * and a single focused panel in the middle.
 */
import type { ReactNode } from 'react';
import { Wordmark } from './Wordmark';
import styles from './AuthShell.module.css';

export interface AuthShellProps {
  /** Big headline above the panel. */
  headline: string;
  /** Supporting line under the headline. */
  subline?: string;
  children: ReactNode;
  /** Small link/text under the panel. */
  footer?: ReactNode;
}

/** Shared frame for the identity / invite / admin gates. */
export function AuthShell({ headline, subline, children, footer }: AuthShellProps) {
  return (
    <div className={styles.shell}>
      <div className={styles.backdrop} aria-hidden="true" />
      <header className={styles.top}>
        <Wordmark size="lg" />
      </header>
      <main className={styles.center}>
        <h1 className={styles.headline}>{headline}</h1>
        {subline ? <p className={styles.subline}>{subline}</p> : null}
        <div className={styles.panel}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </main>
    </div>
  );
}
